import { render, staticRenderFns } from "./AppContacts.vue?vue&type=template&id=4006e8a6"
import script from "./AppContacts.vue?vue&type=script&lang=ts"
export * from "./AppContacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports